'use client';

/*
Parrainage — mise en page alignée sur la homepage v5.
*/
import Head from '@/core/head';
import { Markdown, lang, hocT } from '@/helpers/translate';
import { getCanonicalUrl } from '@/helpers/router.js';
import TypeForm from '@/core/typeform';
import { FadeUp, Stagger, StaggerChild } from '@/core/motion';
import {
  SECTION, CARD, BTN_PRIMARY, Kicker, ArrowIcon, kicker,
} from '@/core/editorial';

const OFFERS = [
  { key: 'host', form: 'https://officeriders.typeform.com/to/mtbZKQ' },
  { key: 'rider', form: 'https://officeriders.typeform.com/to/kEIrGL' },
];

export default hocT(({ t }) => {
  const langCurrent = lang();
  const canurls = getCanonicalUrl('sponsorship', langCurrent);

  return (
    <div className="bg-white font-display text-was-ink">
      <Head>
        {canurls.map((cprops) => <link key={JSON.stringify(cprops)} {...cprops} />)}
      </Head>
      <section className="bg-white">
        <div className={`${SECTION} pt-28 lg:pt-36`}>
          <FadeUp>
            <Kicker n="01">{kicker(langCurrent, 'sponsorship', 0)}</Kicker>
            <h1 className="mt-5 max-w-[820px] text-balance font-heading text-[32px] font-extrabold uppercase leading-[1.04] tracking-[-0.01em] md:text-[40px] lg:text-[46px]">{t('sponsorship:title')}</h1>
          </FadeUp>
          <Stagger stagger={0.1} delay={0.1} className="mt-12 grid gap-6 md:grid-cols-2 lg:mt-16 lg:gap-8">
            {OFFERS.map(({ key, form }, i) => (
              <StaggerChild key={key} className={`flex flex-col p-8 lg:p-10 ${CARD}`}>
                <span className="text-sm tabular-nums text-was-muted">{String(i + 1).padStart(2, '0')}</span>
                <h2 className="m-0 mt-3 text-[22px] font-bold leading-tight tracking-[-0.02em]">{t(`sponsorship:h2_${key}`)}</h2>
                <p className="m-0 mt-4 text-[15px] leading-relaxed text-was-slate">{t(`sponsorship:p_${key}`)}</p>
                <Markdown className="mt-3 text-[15px] leading-relaxed text-was-slate [&_strong]:font-medium [&_strong]:text-was-ink">{t(`sponsorship:p_${key}_2`)}</Markdown>
                <div className="mt-8 border-t border-was-ink/8 pt-6">
                  <TypeForm>
                    {({ openTypeForm }) => (
                      <button type="button" className={BTN_PRIMARY} onClick={() => openTypeForm(form)}>
                        {t('sponsorship:cta_host')}
                        <ArrowIcon />
                      </button>
                    )}
                  </TypeForm>
                </div>
              </StaggerChild>
            ))}
          </Stagger>
        </div>
      </section>
    </div>
  );
});
